import { get } from '.';
import qs from 'qs';

export const getThemes = ({ filters }) => {
  return get(`/themes?${qs.stringify(filters)}`);
};
